import { Box } from "@mui/material";

import { DashboardIcon } from "@/dashboard-design-system/Icon/DashboardIcon";
import { Error, Success as CheckCircle, Info, Warning } from "@/icons/outlined";

export const iconWithBackgroundVibeOptions = ["brand", "danger", "warning", "positive", "neutral"] as const;
export type IconWithBackgroundVibe = (typeof iconWithBackgroundVibeOptions)[number];

export const IconWithBackground = ({ vibe, icon }: { vibe: IconWithBackgroundVibe; icon?: React.ReactNode }) => {
  const vibeIcon = (() => {
    if (vibe === "brand") {
      return <Info />;
    }
    if (vibe === "danger") {
      return <Error />;
    }
    if (vibe === "warning") {
      return <Warning />;
    }
    if (vibe === "positive") {
      return <CheckCircle />;
    }
  })();

  return (
    <Box
      sx={(theme) => ({
        padding: 0.75,
        background: theme.palette.surface[vibe].quiet,
        display: "inline-flex",
        borderRadius: 1,
      })}
    >
      <DashboardIcon vibe={`text-${vibe}-quiet`} size="large">
        {icon || vibeIcon}
      </DashboardIcon>
    </Box>
  );
};
